import React from "react"
import { type BlockProps } from "."
import { graphql, getFragment } from "@/api"

export const ImageFragment = graphql(`
  fragment FrontpagesImage on FrontpagesImage {
    id
    url
    desktopAltText
    desktop {
      data
      width
      height
      pngDesktop
      pngDesktop2x
      pngTablet
      pngTablet2x
      webpDesktop
      webpDesktop2x
      webpTablet
      webpTablet2x
    }
    mobileAltText
    mobile {
      data
      width
      height
      pngMobile
      pngMobile2x
      webpMobile
      webpMobile2x
    }
  }
`)

const LinkOptional: React.FC<{ children: React.ReactNode; url?: string | null }> = ({ url, children }) => {
  if (url) {
    return (
      <a href={url} data-gtm="fp-image-link">
        {children}
      </a>
    )
  }

  return <div>{children}</div>
}

const ImageBlock: React.FC<BlockProps<typeof ImageFragment>> = ({ blockable, demo }) => {
  const block = getFragment(ImageFragment, blockable)

  return (
    <>
      {block.desktop && (
        <div className="container hidden pt-0 sm:block">
          <LinkOptional url={block.url}>
            <picture>
              <source
                srcSet={`${block.desktop.webpDesktop}, ${block.desktop.webpDesktop2x} 2x`}
                media="(min-width: 1280px)"
                type="image/webp"
              />
              <source
                srcSet={`${block.desktop.pngDesktop}, ${block.desktop.pngDesktop2x} 2x`}
                media="(min-width: 1280px)"
              />
              <source srcSet={`${block.desktop.webpTablet}, ${block.desktop.webpTablet2x} 2x`} type="image/webp" />
              <img
                srcSet={`${block.desktop.pngTablet}, ${block.desktop.pngTablet2x} 2x`}
                alt={block.desktopAltText || ""}
                width={block.desktop.width || 0}
                height={block.desktop.height || 0}
                className="h-auto w-full"
                loading="lazy"
              />
            </picture>
          </LinkOptional>
        </div>
      )}
      {!block.desktop && demo && <div className="hidden select-none p-6 text-sm sm:block">No desktop image</div>}
      {block.mobile && (
        <div className="container sm:hidden">
          <LinkOptional url={block.url}>
            <picture>
              <source srcSet={`${block.mobile.webpMobile}, ${block.mobile.webpMobile2x} 2x`} type="image/webp" />
              <img
                srcSet={`${block.mobile.pngMobile}, ${block.mobile.pngMobile2x} 2x`}
                alt={block.mobileAltText || ""}
                width={block.mobile.width}
                height={block.mobile.height}
                className="h-auto w-full"
                loading="lazy"
              />
            </picture>
          </LinkOptional>
        </div>
      )}
      {!block.mobile && demo && <div className="select-none p-6 text-sm sm:hidden">No mobile image</div>}
    </>
  )
}

export default ImageBlock
